<div id="tile">
    <div id="tilecontainer"  class="live-preview-container" [ngClass]="tabIndex === 0 || tabIndex === -1 ? 'new-previews-live-preview-container': '' ">
        <ng-container *ngTemplateOutlet="mainTileFunctions"></ng-container>
        <iposcen-content-live-preview [sidenav]="globalConstant.CUSTOM_TILE" [customTilepresentpage]="presentPage" 
        [customTiletabindex]="tabIndex" *ngIf="!tabIndex || tabIndex === -1">
        </iposcen-content-live-preview>
        <!-- Live preview  -->
        <iposcen-live-preview *ngIf="tabIndex === 4 || tabIndex === 5 || tabIndex === 6 "></iposcen-live-preview>
        <!-- Layout of preview -->
        <div id="layout" class="preview_layout" *ngIf="showPreviewLayout && (tabIndex === 4 || tabIndex === 5 || tabIndex === 6)">
            <div id="LCGcard1" class="card">
                <img src="{{LCGlayout === 1 ?  'assets/images/prev_layout_selected_1.svg': 'assets/images/prev_layout_1.svg'}}"
                    alt="layout 1" (click)="setLayout(1)" class="cursor-pointer" />
            </div>
            <div id="LCGcard2" class="card">
                <img src="{{LCGlayout === 2 ?  'assets/images/prev_layout_selected_2.svg': 'assets/images/prev_layout_2.svg'}}"
                    alt="layout 2" (click)="setLayout(2)" class="cursor-pointer" />
            </div>
            <div id="LCGcard3" class="card">
                <img src="{{LCGlayout === 3 ?  'assets/images/prev_layout_selected_3.svg': 'assets/images/prev_layout_3.svg'}}"
                    alt="layout 3" (click)="setLayout(3)" class="cursor-pointer" />
            </div>
        </div>
    </div>
    <div id="newHTATab" class="preview_control">
        <ng-container *ngTemplateOutlet="header"></ng-container>
        <div class="tab-content pages-tabs" id="newHTATab-content">
            <div id="newHTATabPane" class="tab-pane fade show active" [ngClass]="{'p-0': mainTileFunction && mainSaveDone}"id="alAddHeroTile" role="tabpanel">
                <div id="pages" class="pages_default_tab">
                    <ng-container *ngTemplateOutlet="formBody"></ng-container>
                </div>
            </div>
        </div>
        <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>
</div>
<ng-template #mainTileFunctions>
    <div id="mainTileContainer" class="content-conatiner" [ngClass]="tabIndex === 0 || tabIndex === -1 ? 'new-previews-content-container': '' ">
        <div id="mainTileLabel"><span i18n="@@custom-tile.asset-Library.main-title-header"><strong>Main Tile Function</strong></span></div>
        <div id="mainTileRadio" class="radio-container">
            <input type="radio" #enablePages (change)="setFormData(0,multipleChnage)" class="m-auto radio-button">
            <div id="contentPages" class="text-left pl-2">
                <div id="contentLabel" ><span i18n="@@custom-tile.asset-Library.content-pages"><strong>Content Pages</strong></span></div>
                <div id="contentText" class="input-lable sub-text"><span i18n="@@custom-tile.asset-Library.display-upto">Display up to 3 customizable pages.</span></div>
            </div>
        </div>
        <div id="ORLabel" i18n="@@banner-function.text.or-label">OR</div>
        <div id="urlRadio" class="radio-container">
            <input type="radio" #enableUrl (change)="setFormData(0,multipleChnage)"
                class="radio-button radio-button-align">
            <div id="urlExpLabel" class="text-left pl-2">
                <div id="urlExpTxt"><span i18n="@@custom-tile.asset-Library.url-exp"><strong>URL Experience</strong></span></div>
                <div id="urlExpSubTxt" class="input-lable sub-text"><span i18n="@@custom-tile.asset-Library.launch-a-url">Launch a URL.</span></div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #header>
    <ul class="nav nav-tabs" id="newHTATab" role="tablist">
        <li class="nav-item">
            <a (click)="ontabChange(1)" class="nav-link" [ngClass]="{'inactive':mainSaveDone,'active':!mainSaveDone}" data-toggle="tab"
                role="tab">
                <span>{{mainSaveDone || editObject ?
                    configarationEdit.publishedName:assetLibrabyConstant.NEW_CUSTOM_HERO_TILE_ASSET}}</span>
            </a>
        </li>
        <li *ngIf="tabIndex === 0 " class="nav nav-tab" id="newHTAtabs" role="tablist">
            <a class="nav-link" [ngClass]="{'inactive':!mainSaveDone,'active':mainSaveDone}" data-toggle="tab"
                role="tab">
                <span i18n="@@banner-function.radio-type.url-exp">URL Experience</span>
            </a>
        </li>
        <li class="nav-item" *ngIf="pages && pages.page1 && ((mainTileFunction && mainSaveDone) || editObject)">
            <a class="nav-link gtmAssetLibraryLogoContentPage1" data-toggle="tab" [ngClass]="{'active': tabIndex === 4}"
                (click)="clickable?setIndex(4):false"><span i18n="@@custom-tile.asset-Library.page1">PAGE 1</span>
                <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
                <!-- <div class="page_container">
                    <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page1">PAGE 1</span>&nbsp;</div>
                    <div class="delete_page" *ngIf="pagelen > 1" (click)="clickable?openPopup(delete,0):false"></div>
                </div> -->
            </a>
        </li>
        <li class="nav-item" *ngIf="pages && pages.page2 && ((mainTileFunction && mainSaveDone) || editObject)">
            <a class="nav-link gtmAssetLibraryLogoContentPage2" data-toggle="tab" [ngClass]="{'active': tabIndex === 5}"
                (click)="clickable?setIndex(5):false"><span i18n="@@custom-tile.asset-Library.page2">PAGE 2</span>
                <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
                <!-- <div class="page_container">
                    <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page2">PAGE 2</span>&nbsp;</div>
                    <div class="delete_page" (click)="clickable?openPopup(delete,1):false"></div>
                </div> -->
            </a>
        </li>
        <li class="nav-item" *ngIf="pages && pages.page3 && ((mainTileFunction && mainSaveDone) || editObject)">
            <a class="nav-link gtmAssetLibraryLogoContentPage3" data-toggle="tab" [ngClass]="{'active': tabIndex === 6}"
                (click)="clickable?setIndex(6):false"><span i18n="@@custom-tile.asset-Library.page3">PAGE 3</span>
                <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
                <!-- <div class="page_container">
                    <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page3">PAGE 3</span>&nbsp;</div>
                    <div class="delete_page" (click)="clickable?openPopup(delete,2):false"></div>
                </div> -->
            </a>
        </li>
        <li class="nav-item" *ngIf="(clickable && !checkPages()) && (mainTileFunction && mainSaveDone)">
            <a class="nav-link gtmAssetLibraryLogoContentAddPage" data-toggle="tab" (click)="addPage()">
                <img src="assets/images/add_black_square_outline.svg" alt="exit without changes" />
            </a>
        </li>
        <li class="nav-item exit_preview">
            <a class="nav-link gtmAssetLibraryCreateHeroTileCancel" (click)="cancel()">
                <img class="exit_changes" alt="exit without changes" />
            </a>
        </li>
    </ul>
</ng-template>
<ng-template #formBody>
    <div *ngIf="!mainSaveDone" class="section-continer col-12" id="main">
        <!-- 1st  section  -->
        <div id="section" class="section-decoration section-padding col-3">
            <!-- publish name  -->
            <div id="publishName">
                <div id="publishNameTxt"><span i18n="@@custom-tile.asset-Library.publish-name">Published Name</span>&nbsp;<span class='text-danger'>*</span></div>
                <input type="text" maxlength="50" [value]="publishValue"
                    [placeholder]="assetLibrabyConstant.PUBLISHED_NAME_PLACEHOLDER" class="form-control"
                    (input)="setFormData(1,$event.target.value)">
            </div>
            <!-- publish name end  -->

            <!-- internal name  -->
            <div id="internalName" class="mt-3">
                <div id="internalNameTxt"><span i18n="@@custom-tile.asset-Library.internal-name">Internal Name</span></div>
                <input type="text" [value]="internalValue" maxlength="50"
                    [placeholder]="assetLibrabyConstant.INTERNAL_NAME_PLACEHOLDER" class="form-control"
                    (input)="setFormData(2,$event.target.value)">
            </div>
            <!-- internal name end  -->
        </div>
        <!-- 1st section end  -->

        <!-- 2nd section  -->
        <div id="section2" class="section-decoration section-padding col-3">
            <!-- main tile Image  -->
            <div id="heroTileImg">
                <label for="uploadedHeroTileImage">
                    <span class="input-lable input-lable" i18n="@@custom-tile.asset-Library.main-tile-image">Main Tile Image</span><span class="text-danger"> *</span>
                    <img class="info_icon" alt="hover for help" placement="top" [ngbPopover]="popContent"
                        triggers="mouseenter:mouseleave" />
                </label>
                <div id="uploadButton">
                    <div id="heroTileSection" class="d-flex">
                        <label class="uploadHeroTileLabel" dir="{{direction}}">
                            <input #imageHeroTileInput id="uploadHeroTile" type="file"
                                accept="image/jpg,image/jfif,image/x-png,image/jpeg,image/gif"
                                (change)="setFormData(3,imageHeroTileInput)" hidden>
                            <span class="btn btn-primary btn-sm left_icon_btn">
                                <img class="upload_image" alt="upload image" />
                                <span i18n="@@custom-tile.asset-Library.upload-image">Upload Image</span>
                            </span>
                        </label>
                        <div id="recommendedMsg" class="message ml-3" dir="{{direction}}">
                            <span i18n="@@custom-tile.asset-Library.recommended-ratio">Recommended Aspect ratio 18:5</span>
                        </div>                    </div>
                    <div id="addText" class="additions-text">
                        {{imageMainData? imageMainData.fileName:null}}
                    </div>
                    <div id="errMsg" *ngIf="errorMessageMainImage.isError" class="additions-text">
                        <div id="errMsgImage" *ngIf="errorMessageMainImage.sizeError" class="text-danger">
                            <span i18n="@@custom-tile.asset-Library.allowed-size-5">Allowed maximum size is<strong> 5 MB</strong></span>
                        </div>
                        <div id="errMsgType" *ngIf="errorMessageMainImage.typeError" class="text-danger">
                            <span i18n="@@create-hero-tile.image-format-popover">Images must be in <strong>JPG, PNG, JPEG, JFIF</strong> or <strong>GIF</strong>
                                format.</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- main tile asset  end-->
            <!-- IIT2-15095 -->
            <div id="hColor" class="form-group color-container BGColumn mt-3">
                <label for="" i18n="@@page.content.bg-color">Background color</label>
                <input readonly [(colorPicker)]="bgColor" [cpPosition]="'right'" [style.background]="bgColor" class="color_picker_button" (colorPickerChange)="emitPageDataToPreview()" role="button">
            </div>
            <!-- gaming banner  -->
            <div id="gamingBaner" class="mt-3">
                <label for="uploadGamingBanner">
                    <span class="input-lable input-lable" i18n="@@custom-tile.asset-Library.gaming-creator-banner">Gaming/Creator IPOS Banner</span><span class="text-danger">
                        *</span>
                    <img class="info_icon" alt="hover for help" placement="right" [ngbPopover]="popContent"
                        triggers="mouseenter:mouseleave" />
                </label>
                <div id="uploadButton">
                    <div id="uploadSection" class="d-flex">
                        <label class="uploadHeroTileLabel">
                            <input #imageInputBanner type="file"
                                accept="image/jpg,image/jfif,image/x-png,image/jpeg,image/gif"
                                (change)="setFormData(4,imageInputBanner)" hidden />
                            <span class="btn btn-primary btn-sm left_icon_btn">
                                <img class="upload_image" alt="upload image" />
                                <span i18n="@@custom-tile.asset-Library.upload-image">Upload Image</span>
                            </span>
                        </label>
                        <div id="recommendedMsg2" class="message ml-3" dir="{{direction}}"><span i18n="@@custom-tile.asset-Library.recommended-ratio-9">Recommended Aspect ratio 9:5</span></div>
                    </div>
                    <div id="imgAddtxt" class="additions-text">
                        {{imageBannerData? imageBannerData.fileName:null}}
                    </div>
                    <div id="errMsgImage1" *ngIf="errorMessageBannerImage.isError" class="additions-text">
                        <div *ngIf="errorMessageBannerImage.sizeError" class="text-danger">
                            <span i18n="@@custom-tile.asset-Library.allowed-size-5">Allowed maximum size is<strong> 5 MB</strong></span>
                        </div>
                        <div id="errMsgType1" *ngIf="errorMessageBannerImage.typeError" class="text-danger">
                            <span i18n="@@create-hero-tile.image-format-popover">Images must be in <strong>JPG, PNG, JPEG, JFIF</strong> or <strong>GIF</strong>
                                format.</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- gaming banner end  -->
            <!-- IIT2-15095 -->
            <div id="hColor" class="form-group color-container BGColumn mt-3">
                <label for="" i18n="@@page.content.bg-color">Background color</label>
                <input readonly [(colorPicker)]="gamingBgColor" [cpPosition]="'right'" [style.background]="gamingBgColor" class="color_picker_button" (colorPickerChange)="emitPageGamingDataToPreview()" role="button">
            </div>
            <!-- call to action  -->
            <div id="call2action" class="mt-3">
                <label for=""><span class="input-lable" i18n="@@custom-tile.asset-Library.call-to-action">Call-to-Action</span><span class="text-danger">*</span></label>
                <input type="text" class="form-control" [value]="callToAction"
                    [placeholder]="assetLibrabyConstant.CALL_TO_ACTION_CUSTOM_PLACEHOLDER"
                    (input)="setFormData(5,$event.target.value)" maxlength="50" required />
                <em class="err_icon"></em>
                <span id="emailErrMsg" class="formfield_err_msg"></span>
            </div>
            <!-- call to action end  -->
        </div>
        <!-- 2nd section end  -->
    <div id="publishedTimeStamp" class="col-3 ml-3 timeStamp" dir={{direction}}>   
        <div id="timeStamp">
            <label for="publishedTimeStamp">
                <span i18n="@@create-price-content.priceContentgrpForm.published-date-time">Publishing Date and Time</span>
            </label>
            <div id="publishDate" class="publishDate-Section">
                <div id="dateRadio">
                    <input type="radio" name="publishdate" id="now" class="form-check-input" id="now"
                        [checked]="!isPublishDateCustomDatepickerCustomTile" (click)="selectCustomPublishDate('Now')" />
                    <label for="now">
                        <span i18n="@@create-price-content.priceContentgrpForm.never">Now</span>
                    </label>
                </div>
                <div id="datePicker"class="custom-datepicker">
                    <input type="radio" name="publishdate" id="publish-date-custom" [ngClass]="isPublishDateCustomDatepickerCustomTile ? 'custom-date':''" class="form-check-input"
                        id="publish-date-custom" [checked]="isPublishDateCustomDatepickerCustomTile"
                        (click)="selectCustomPublishDate('custom')" />
                    <label for="publish-date-custom" *ngIf="!isPublishDateCustomDatepickerCustomTile"
                        i18n="@@create-price-content.custom-datepicker.custom">Custom</label>
                    <div id="dateTimeZone" *ngIf="isPublishDateCustomDatepickerCustomTile">
                        <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'publish')"
                            (getDateTimeZoneData)="getLogoContentPublishDate($event)" (isTimeZoneSelected)="checkTimeZone($event,'publish')" 
                            [publishDateInfo]="editPublishDateInfoCustomTile" [divideDate]="divideDateFormat">
                        </iposcen-date-time-zone>
                    </div>
                </div>
                <div id="dateCorrect" *ngIf="isCustomPublishDateCorrectCustomTile || isCustomPublishTimeZoneSelected" class="formfield_err_msg">
                    <span i18n="@@create-price-content.priceContentgrpForm.now">Please select publishing date and time
                        zone.</span>
                </div>
            </div>
        </div>
        <div id="expiryDateTime">
            <label for="publishedTimeStamp">
                <span i18n="@@create-price-content.publishedTimeStamp.expiry-date-time">Expiration Date and Time</span>
            </label>
            <div id="expiryDate" class="publishDate-Section">
                <div id="neverDate">
                    <input type="radio" name="expiryDate" id="never" class="form-check-input" id="never"
                        [checked]="!isExpiryDatePickerCustomTile" (click)="selectExpiryDateTimeZone('Never')" />
                    <label for="never">
                        <span i18n="@@create-price-content.publish-date.never">Never</span>
                    </label>
                </div>
                <div id="expiryCustom" class="custom-datepicker">
                    <input type="radio" name="expiryDate" id="expiry-custom"  [ngClass]="isExpiryDatePickerCustomTile ? 'custom-date':''" class="form-check-input" id="expiry-custom"
                        [checked]="isExpiryDatePickerCustomTile" (click)="selectExpiryDateTimeZone('custom')" />
                    <label for="expiry-custom" *ngIf="!isExpiryDatePickerCustomTile">
                        <span i18n="@@create-price-content.custom-datepicker.custom">Custom</span>
                    </label>
                    <div id="expiryDateInfo" *ngIf="isExpiryDatePickerCustomTile">
                        <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'expiry')"
                            (getDateTimeZoneData)="getLogoContentExpiryDate($event)" (isTimeZoneSelected)="checkTimeZone($event,'expiry')"
                            [expiryDateInfo]="editexpiryDateInfoCustomTile" [divideDate]="divideDateFormat">
                        </iposcen-date-time-zone>
                    </div>
                </div>
                <div id="DateIncorrect" *ngIf="isExpiredDateIncorrectCustomTile" class="formfield_err_msg">
                    <span i18n="@@create-price-content.custom-datepicker.expiry-less-than-publish">Expiration date should not be
                        before publishing date.</span>
                </div>
                <div id="DateCorrectCustom" *ngIf="isCustomExpiryDateCorrectCustomTile || isCustomExpiryTimeZoneSelected" class="formfield_err_msg">
                    <span i18n="@@create-price-content.custom-datepicker.please-select-expiry-date-time">Please select
                        expiration date and time zone.</span>
                </div>
            </div>
        </div>
    </div>
        <!-- 3rd section  -->
        <div id="section3" class="section-padding col-3">
            <label for=""><span i18n="@@custom-tile.asset-Library.apply-content-group-to">Apply content group to</span></label>
            <button type="button" class="btn btn-primary btn-sm left_icon_btn gtmFormFctrBanner"
                (click)="openFormFactorsModal()">
                <img class="laptop_icon_formFactor" alt="select form factors" />
                <span i18n="@@custom-tile.asset-Library.select-form-factors">Select Form Factors</span>
            </button>
            <iposcen-form-factors #formFactorsModal [contentName]="selectedFormFactors" [isAllEnabled]="true"
                (applyFormFactor)="applyFormFactor($event)"></iposcen-form-factors>
            <div id="formFactors" *ngIf="selectedFormFactors" class="selected_factors mt-2">
                <div id="manufacturerSec">
                    <div id="manufacturers" class="font-bold inline-block"><span>{{manufacturers}}</span>: </div>
                    <div id="FFManufcturer" class="inline">&nbsp;<span>{{ selectedFormFactors?.manufacturer}} </span></div>
                </div>
                <div id="deviceSec">
                    <div id="devices" class="font-bold inline-block"><span>{{deviceTypes}}</span>: </div>
                    <div id="FFDevices" class="inline">&nbsp;<span>{{ selectedFormFactors?.devices}} </span></div>
                </div>
                <div id="processorSec">
                    <div id="processors" class="font-bold inline-block"><span>{{processors}}</span>: </div>
                    <div id="FFProcessors" class="inline">&nbsp;<span>{{ selectedFormFactors?.processors}}</span></div>
                </div>
                <div id="generationSec">
                    <div id="generation" class="font-bold inline-block"><span>{{generation}}</span>: </div>
                    <div id="FFGenerations" class="inline">&nbsp;<span>{{ selectedFormFactors.generations}}</span></div>
                </div>
            </div>
        </div>
        <!-- 3rd section end  -->
    </div>
    <div id="urlContainer" *ngIf="!mainTileFunction && mainSaveDone" class="url-continer" id="urlexp">
        <div id="reqNote"><span i18n="@@custom-tile.asset-Library.note-funtionality-req-device">Note: This functionality requires a connected device to access the custom URL.</span></div>
        <div id="customURL" class="mt-2"><span i18n="@@custom-tile.asset-Library.custom-url">Custom URL <span class="text-danger">*</span></span></div>
        <div id="urlInput">
            <input type="text" class="url-input mt-3" [value]="urlInput" (input)="setFormData(6,$event.target.value)" />
            <div *ngIf="errorUrlExp.urlValid" class="text-danger"><span i18n="@@custom-tile.asset-Library.custom-url-error-message">Please enter a valid URL</span></div>
        </div>
        <div></div>
    </div>
    <div *ngIf="mainTileFunction && mainSaveDone" id="page">
        <div id="tab4" *ngIf="tabIndex === 4">
            <iposcen-page #page1 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=1
                [mediaObjs]="mediaObjects" (goBacktoLogoContent)="refreshLGCdata()" (isBodyError)='getPageError($event)'
                (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
        </div>
        <div id="tab5" *ngIf="tabIndex === 5">
            <iposcen-page #page2 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=2
                [mediaObjs]="mediaObjects" (goBacktoLogoContent)="refreshLGCdata()" (isBodyError)='getPageError($event)'
                (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
        </div>
        <div id="tab6" *ngIf="tabIndex === 6">
            <iposcen-page #page3 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=3
                [mediaObjs]="mediaObjects" (goBacktoLogoContent)="refreshLGCdata()" (isBodyError)='getPageError($event)'
                (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
        </div>
    </div>
</ng-template>
<ng-template #footer>
    <div id="cancelBtn" class="button_wrapper justify-content-end" *ngIf="!mainSaveDone || !tabIndex || tabIndex === -1">
        <button type="button" class="btn btn-outline-primary gtmAssetLibraryCreateHeroTileCancel" (click)="cancel()">
            <span>{{globalConstant.CANCEL}}</span>
        </button>
        <button type="button" class="btn btn-primary gtmAssetLibraryCreateHeroTileSaveAndProceeed"
            [disabled]='!this.publishValue || !this.callToAction || !this.selectedFormFactors || !this.imageMainData.file || !this.imageBannerData.file || ((this.errorUrlExp.urlValid || !this.urlInput) && this.mainSaveDone )'
            (click)="save()">
            <span class="gtmAssetLibraryCreateHeroTileSaveAndProceeed">{{globalConstant.SAVE_AND_PROCEED}}</span>
        </button>
    </div>
    <div id="addBtn" class="button_wrapper justify-content-end"
        *ngIf="mainSaveDone && (tabIndex === 4 || tabIndex === 5|| tabIndex === 6)">
        <button type="button" class="btn btn-outline-primary left_icon_btn gtmAddPageLogo" (click)="addPage()"
            *ngIf="!isPage3Created">
            <img src="assets/images/plus_square_outline.svg" alt="add page" />
            <span i18n="@@custom-tile.asset-Library.add-pages">Add Page</span>
        </button>
        <button type="button" class="btn btn-primary gtmSaveLogoContGrp"
            (click)="pageError.get(1)||pageError.get(2)||pageError.get(3)?openPopupError(errorPopup):updateCustomTile()">
            {{globalConstant.SAVE_CHANGES}}
        </button>
    </div>
    <iposcen-showon-device #showModal (show)="showOnDevice()" (closePopup)="closeShowOnDevice()">
    </iposcen-showon-device>
    
     <iposcen-apply-changes-to-devices #applyModal (apply)="applyToDevice(true)" (closePopup)="applyToDevice(false)">
      </iposcen-apply-changes-to-devices>
</ng-template>
<!-- //popup page delete  -->
<ng-template #delete let-modal>
    <div id="confrmPopUp" class="card confirmPopup">
      <div id="modalHeader" class="modal-header">
        <div id="modalCloseIcon" (click)="modal.close()" class="close-icon">
          <img src="../../../../../../assets/images/popup_close_button.svg" alt="close icon" />
        </div>
      </div>
      <div id="modalBody" class="modal-body popup-body">
        <div id="modalBodyTitle">
          <h2 class="mt-3">
            <span i18n="@@create-partner-content.delete-modal.delete-page?">Delete Page?</span>
          </h2>
          <div id="modalBodyText" class="card-desc">
            <span i18n="@@create-partner-content.delete-modal.remove-permanently">This content will be removed permanently.</span>
          </div>
        </div>
      </div>
      <div id="modalFooter" class="modal-footer card-footer">
        <button type="button" (click)="modal.close()" class="btn btn-outline-primary btn-cancel">
          <span i18n="@@create-partner-content.delete-modal.cancel">Cancel</span>
        </button>
        <button type="button" class="btn btn-primary btn-confirm" (click)="modal.close();deletePages(whichPageDelete)">
          <span i18n="@@create-partner-content.delete-modal.delete-page">Delete Page</span>
        </button>
      </div>
    </div>
  </ng-template>
<ng-template #popContent>
    <div id="popOver" class="popover-upload-req">
        <div id="popOverSec" class="d-flex align-items-center">
            <img src="assets/images/image-icon.png" alt="image" />
            <ul>
                <li>
                    <span i18n="@@create-hero-tile.image-format-popover">Images must be in <strong>JPG, PNG, JPEG, JFIF</strong> or <strong>GIF</strong> format.</span></li>
                <li *ngIf="!isRemoveEnabled">
                    <span i18n="@@global.tooltip.image-max-size-error">Allowed maximum size is <strong>5 MB</strong></span>
                </li>
            </ul>
        </div>
    </div>
</ng-template>
<ng-template #errorPopup let-modal>
    <div id="confirmPopup" class="card confirmPopup">
        <div id="confirmHeader" class="modal-header">
            <div id="closeBtn" (click)="modal.close()" class="close-icon">
                <img src="../../../../assets/images/popup_close_button.svg" alt="close icon" />
            </div>
        </div>
        <div id="confirmBody" class="modal-body popup-body">
            <div id="bodySec">
                <div id="confirmCardDesc" class="card-desc">
                    <span *ngIf='pageError.get(1) && !pageError.get(2) && !pageError.get(3)'>{{errorMessageText}}</span>
                    <span
                        *ngIf='pageError.get(1) && pageError.get(2)  && !pageError.get(3)'>{{errorMessageText1}}</span>
                    <span
                        *ngIf='pageError.get(1) && pageError.get(3)  && !pageError.get(2)'>{{errorMessageText2}}</span>
                    <span
                        *ngIf='pageError.get(2) && !pageError.get(3) && !pageError.get(1)'>{{errorMessageText3}}</span>
                    <span
                        *ngIf='pageError.get(2) && pageError.get(3)  && !pageError.get(1)'>{{errorMessageText4}}</span>
                    <span
                        *ngIf='pageError.get(3) && !pageError.get(1) && !pageError.get(2)'>{{errorMessageText5}}</span>
                    <span *ngIf='pageError.get(3) && pageError.get(1) && pageError.get(2)'>{{errorMessageText6}}</span>
                </div>
            </div>
        </div>
        <div id="confirmFooter" class="modal-footer card-footer">
            <button type="button" (click)="modal.close();goToErrorPage()" class="btn btn-primary btn-confirm">
                <span>{{buttonLable}}</span>
            </button>
        </div>
    </div>
</ng-template>
<ng-template #multipleChnage let-modal>
    <div id="changePopup" class="card confirmPopup">
        <div id="changeHeader" class="modal-header">
            <div id="openPopup" (click)="openMainFuntionPopup(modal,null)" class="close-icon">
                <img src="../../../../assets/images/popup_close_button.svg" alt="close icon" />
                <!-- <span class="close_icon"></span> -->
            </div>
        </div>
        <div id="changeBody" class="modal-body popup-body">
            <div id="addURLContent">
                <h2>
                    <span *ngIf="!mainTileFunction" i18n="@@custom-tile.asset-Library.add-content-pages">Add Content Pages?</span>
                    <span *ngIf="mainTileFunction" i18n="@@custom-tile.asset-Library.add-url-exp-question">Add URL Experience?</span>
                </h2>
                <div id="addDesc" class="card-desc">
                    <span *ngIf="!mainTileFunction" i18n="@@custom-tile.asset-Library.this-will-remove-url-exp">This will remove the URL experience from this group.</span>
                    <span *ngIf="mainTileFunction" i18n="@@custom-tile.asset-Library.this-will-remove-pages">This will remove the content pages from this group.</span>
                </div>
            </div>
        </div>
        <div id="cardFooter" class="modal-footer card-footer">
            <button type="button" (click)="openMainFuntionPopup(modal,null)" class="btn btn-outline-primary btn-cancel">
                <span>{{globalConstant.CANCEL}}</span>
            </button>
            <button type="button" class="btn btn-primary btn-confirm" (click)="openMainFuntionPopup(modal,true)">
                <span *ngIf="!mainTileFunction" i18n="@@custom-tile.asset-Library.add-content-pages-button">Add Content Pages</span>
                <span *ngIf="mainTileFunction" i18n="@@custom-tile.asset-Library.add-url-exp-button">Add URL Experience</span>
            </button>
        </div>
    </div>
</ng-template>